<template>
  <div class="order-create f-c" v-loading="loadingData">
    <basic-form ref="orderForm" title="Order Info" :show-clear="true" :mode="FormModes.SPARSE" :form-params="orderForm"
      :change-date="val => (date = val)" :value-change-cb="(key, val) => formValueChange(orderForm, key, val)" />
    <basic-form v-if="[DirectOrder, UnloadingOrder].includes(orderType)" ref="containerForm" title="Container Info"
      :show-clear="true" :mode="FormModes.SPARSE" :form-params="containerForm"
      :value-change-cb="(key, val) => formValueChange(containerForm, key, val)" />
    <basic-form v-if="orderType === ScanOrder" ref="orderVCForm" title="VC Info" :show-clear="true" :mode="FormModes.SPARSE" :form-params="orderVCForm"
      :change-date="val => (date = val)" :value-change-cb="(key, val) => formValueChange(orderVCForm, key, val)" />
    <basic-form v-if="orderType === DirectOrder" ref="deliveryInfoForm" title="Delivery Info" :show-clear="true"
      :mode="FormModes.SPARSE" :form-params="deliveryInfoForm" :value-change-cb="(key, val) => formValueChange(deliveryInfoForm, key, val)
        " />
    <basic-form v-if="DirectOrder === orderType" ref="pickingUpForm" title="Picking Up Info" :show-clear="true"
      :mode="FormModes.SPARSE" :form-params="pickingUpForm"
      :value-change-cb="(key, val) => formValueChange(pickingUpForm, key, val)" />
    <local-pallets-add v-else-if="orderType === LocalOrder" ref="localPallets" />
    <order-scan-create v-else-if="orderType === ScanOrder" ref="scanOrderProducts" :updatePOOptions="updatePOOptions" />
    <common-card title="Packing List" v-if="[DirectOrder, UnloadingOrder, OtherOrder].includes(orderType)">
      <template v-slot:header-ops>
        <div class="upload-buts f-r">
          <el-button type="primary" plain size="small" @click="createOrder" :loading="loadingData" :disabled="hasError">
            Create Order
          </el-button>
          <el-upload ref="upload" action="" :auto-upload="false" accept=".xls,.xlsx" :multiple="false"
            :show-file-list="false" :on-change="selectFileCb">
            <el-button size="small" plain type="success">
              Upload Excel
            </el-button>
          </el-upload>
          <el-button type="primary" plain size="small" @click="donwloadTemplate">
            Template
          </el-button>
        </div>
      </template>
      <div class="packing-list-errors f-r">
        <el-tag plain type="danger" v-for="row in Object.keys(tableErrors)" :key="row" :closable="false"
          @click="jumpToRow(row)">
          Row {{ row }} {{ tableErrors[row] }}
        </el-tag>
      </div>
      <packing-list ref="packingList" :goods="tableData" :showHeaderOps="false"
        :tableRowClass="packingListTableRowClass" :stripe="Object.keys(tableErrors).length === 0">
        <template v-slot:actions="props">
          <el-button size="small" type="text" @click="() => modifyGoods(props.row, props.index)">
            Edit
          </el-button>
          <el-button size="small" type="text" class="danger-text" @click="() => deleteGoods(props.index)">
            Delete
          </el-button>
        </template>
      </packing-list>
      <div class="selector" ref="selector"></div>
    </common-card>
    <ScanOrderUploadPreview ref="uploadScanOrder" v-if="ScanUploadOrders === orderType" />
    <div class="buttons f-r">
      <el-button type="danger" size="small" @click="goBack">
        Cancel Create
      </el-button>
      <el-button
        type="primary"
        size="small"
        @click="createOrder"
        :loading="loadingData"
        :disabled="hasError || loadingData">
        Create Order
      </el-button>
    </div>
    <goods-edit ref="goodsEdit" />
  </div>
</template>
<script>
// others
import get from 'lodash/get'
import cloneDeep from 'lodash/cloneDeep'
import {
  FormModes,
  PositiveFloatValidator,
  PositiveValidator,
  RequiredValidator
} from '@/core/configs/types'
import { parseExcel, downloadExcel } from '@/core/utils/excel'
// mixins
import { pageJumps } from '@/core/mixin/pages'
// apis
import { createOrder, createOrders } from '@/api/order'
// models
import {
  OrderForm,
  DirectDeliveryInfoForm,
  LocalOrderForm,
  DirectOrder,
  OtherOrder,
  UnloadingOrder,
  LocalOrder,
  ScanOrder,
  ScanUploadOrders,
  OrderVCForm,
  validateScanOrderStock
} from '@/core/models/order'
import { ContainerForm, PickUpInfoForm } from '@/core/models/container'
import { GoodsExcelHeaders, PackingListGoodsWrapUp } from '@/core/models/goods'

// components
import BasicForm from '@/components/common/BasicForm.vue'
import PackingList from '@/components/goods/PackingList.vue'
import CommonCard from '@/components/common/CommonCard.vue'
import GoodsEdit from '@/components/goods/GoodsEdit.vue'
import LocalPalletsAdd from '@/components/order/LocalPalletsAdd.vue'
import OrderScanCreate from '@/components/order/OrderScanCreate.vue'
import { NoteWrapUp } from '@/core/models/note'
import ScanOrderUploadPreview from '@/components/order/ScanOrderUploadPreview.vue'
export default {
  name: 'OrderCreate',
  mixins: [pageJumps],
  components: {
    BasicForm,
    PackingList,
    CommonCard,
    GoodsEdit,
    LocalPalletsAdd,
    OrderScanCreate,
    ScanOrderUploadPreview
  },
  data() {
    return {
      FormModes,
      DirectOrder,
      LocalOrder,
      OtherOrder,
      UnloadingOrder,
      ScanOrder,
      ScanUploadOrders,
      orderForm: cloneDeep(OrderForm),
      orderVCForm: cloneDeep(OrderVCForm),
      containerForm: cloneDeep(ContainerForm),
      pickingUpForm: cloneDeep(PickUpInfoForm),
      deliveryInfoForm: cloneDeep(DirectDeliveryInfoForm),
      updatePOOptions: this._updatePOOptions.bind(this),
      tableData: [],
      tableErrors: {},
      loadingData: false,
      FormWrapUp: {
        orderForm: {
          wrapFunc: NoteWrapUp,
          errMsg: 'Order Info is wrong, please check!'
        },
        orderVCForm: {
          wrapFunc: v => v,
          errMsg: 'Order VC Info is wrong, please check!'
        },
        containerForm: {
          wrapFunc: NoteWrapUp,
          errMsg: 'Container Info is wrong, please check!'
        },
        deliveryInfoForm: {
          wrapFunc: NoteWrapUp,
          errMSg: 'Delivery Info is wrong, please check!'
        },
        pickingUpForm: {
          wrapFunc: v => v,
          errMsg: 'PickingUp Info is wrong, please check!'
        }
      }
    }
  },
  computed: {
    orderType() {
      return this.orderForm.type.value
    },
    hasError() {
      return Object.keys(this.tableErrors).length > 0
    }
  },
  watch: {
    orderType: {
      handler: function (val) {
        if (val === LocalOrder) {
          this.$set(this, 'orderForm', cloneDeep(LocalOrderForm))
        } else if (val === ScanUploadOrders) {
          this.$set(this, 'orderForm', {
            type: cloneDeep(OrderForm.type)
          })
        } else {
          this.$set(this, 'orderForm', cloneDeep(OrderForm))
        }
        this.orderForm.type.value = val
      },
      immediate: true
    }
  },
  methods: {
    formValueChange(form, key, val) {
      this.$set(get(form, key), 'value', val)
    },
    selectFileCb(file) {
      this.loadingData = true
      parseExcel(file, { headers: GoodsExcelHeaders }, (res, errors) => {
        console.error('error', errors)
        this.loadingData = false
        this.tableData.splice(0, this.tableData.length)
        this.tableErrors = {}
        this.tableData.push(
          ...res.map((one, index) => {
            const wrapped = PackingListGoodsWrapUp(one)
            wrapped.id = index
            return wrapped
          })
        )
      })
    },
    modifyGoods(row, index) {
      const saveGoods = (data, done, error) => {
        this.$set(this.tableData, index, data)
        // todo: some check for modified data
        done()
      }
      this.$refs.goodsEdit.open(row, saveGoods)
    },
    deleteGoods(index) {
      this.tableData.splice(index, 1)
      this.$delete(this.tableErrors, index)
    },
    _updatePOOptions(options) {
      this.orderVCForm.poNo.options = options
      this.$set(this, 'orderVCForm', {
        ...this.orderVCForm
      })
    },
    createOrder() {
      if (this.loadingData) return
      this.loadingData = true
      const data =
        this.orderType === DirectOrder
          ? this.createDirectOrder()
          : this.orderType === UnloadingOrder
            ? this.createUnloadingOrder()
            : this.orderType === LocalOrder
              ? this.createLocalOrder()
              : this.orderType === ScanOrder
                ? this.createScanOrder()
                : this.orderType === ScanUploadOrders
                  ? this.bulkCreateScanOrder()
                  : null
      const api = this.orderType === ScanUploadOrders
        ? createOrders
        : createOrder

      if (data) {
        api(data)
          .then(res => {
            if (res) {
              this.$message({
                type: 'success',
                message: 'Create order successfully!'
              })
              if (this.orderType !== ScanUploadOrders) {
                this.goToOrderDetail(res)
              } else {
                this.goToSearchOrder({ orderType: ScanOrder }, true)
              }
            }
          })
          .finally(() => {
            this.loadingData = false
          })
      } else {
        this.loadingData = false
      }
    },
    validaInputs(forms) {
      let passed = true
      let inputs = null
      let errMsg = ''
      let i = 0
      while (passed && i < Object.keys(forms).length) {
        const key = Object.keys(forms)[i]
          ;[passed, inputs] = this.$refs[key].validateAllInputs()
        if (passed) {
          forms[key] = this.FormWrapUp[key].wrapFunc(inputs)
        } else {
          errMsg = this.FormWrapUp[key].errMsg
        }
        i += 1
      }
      return [passed, errMsg]
    },
    createDirectOrder() {
      const orderInputs = {
        orderForm: null,
        containerForm: null,
        deliveryInfoForm: null,
        pickingUpForm: null
      }
      const [passed, errMsg] = this.validaInputs(orderInputs)
      if (errMsg) this.$message.error(errMsg)
      if (!passed) return null
      if (this.tableData.length === 0) {
        this.$message.error('Packing list is empty!')
        return null
      }
      return {
        order: orderInputs.orderForm,
        container: orderInputs.containerForm,
        deliveryInfo: orderInputs.deliveryInfoForm,
        pickingUpInfo: orderInputs.pickingUpForm,
        goods: this.tableData
      }
    },
    createUnloadingOrder() {
      const orderInputs = {
        orderForm: null,
        containerForm: null
      }
      const [passed, errMsg] = this.validaInputs(orderInputs)
      if (errMsg) this.$message.error(errMsg)
      if (!passed) return null
      if (this.tableData.length === 0) {
        this.$message.error('Packing list is empty!')
        return null
      }
      return {
        order: orderInputs.orderForm,
        container: orderInputs.containerForm,
        goods: this.tableData
      }
    },
    createLocalOrder() {
      const orderInputs = {
        orderForm: null
      }
      const [passed, errMsg] = this.validaInputs(orderInputs)
      if (errMsg) this.$message.error(errMsg)
      if (!passed) return null
      const pallets = this.$refs.localPallets.getAllPallets()
      if (pallets.length === 0) return null
      return {
        localPallets: pallets,
        order: orderInputs.orderForm
      }
    },
    createScanOrder() {
      const orderInputs = {
        orderForm: null,
        orderVCForm: null
      }
      let res = this.validaInputs(orderInputs)
      if (res[1]) this.$message.error(res[1])
      if (!res[0]) return null
      // getScanOrderProductGroups
      const scanOrderGroups = this.$refs.scanOrderProducts.getScanOrderProductGroups()
      // validate again
      res = validateScanOrderStock(orderInputs.orderForm.customer, orderInputs.orderVCForm, scanOrderGroups)
      if (res[1]) this.$message.error(res[1])
      if (!res[0]) return null
      return {
        scanOrderGroups,
        order: orderInputs.orderForm,
        vcInfo: orderInputs.orderVCForm
      }
    },
    bulkCreateScanOrder() {
      return this.$refs.uploadScanOrder.prepareScanOrders()
    },
    donwloadTemplate() {
      downloadExcel()
    },
    jumpToRow(index) {
      //
      const child = document.querySelector(
        '.order-create-packing-list-' + index
      )
      child.scrollIntoView()
      setTimeout(() => {
        const rect = child.getBoundingClientRect()
        this.$refs.selector.style.display = 'block'
        this.$refs.selector.style.width = rect.width + 'px'
        this.$refs.selector.style.height = rect.height + 'px'
        this.$refs.selector.style.left = rect.x + 'px'
        this.$refs.selector.style.top = rect.y + 'px'
        setTimeout(() => this.listenToScroll(), 2000)
      }, 400)
    },
    packingListTableRowClass(row, index) {
      const errors = []
      const rowKey = 'order-create-packing-list-' + index
      let [flag] = PositiveFloatValidator(row.cmb)
      if (!flag) {
        errors.push('CMB is invalid')
      }
      ;[flag] = RequiredValidator(row.sku)
      if (!flag) {
        errors.push('SKU is invalid')
      }
      ;[flag] = PositiveFloatValidator(row.kilograms)
      if (!flag) {
        errors.push('Kilograms is invalid')
      }
      ;[flag] = PositiveValidator(row.quantity)
      if (!flag) {
        errors.push('Quantity is invalid')
      }
      if (errors.length > 0) {
        this.$set(
          this.tableErrors,
          index,
          (row?.sku ?? '') + ' ' + errors.join(', ')
        )
        return rowKey + ' danger-table-row'
      } else {
        this.$delete(this.tableErrors, index)
      }
      return rowKey
    },
    listenToScroll() {
      if (this.$refs.selector && this.$refs.selector.style.display !== 'none') {
        this.$refs.selector.style.display = 'none'
      }
    }
  },
  beforeMount() {
    window.addEventListener('scroll', this.listenToScroll, true)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.listenToScroll)
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.upload-buts {
  gap: 10px;
}

.buttons {
  gap: 10px;
  justify-content: end;
  margin-right: 20px;
  margin-bottom: 40px;
}

.packing-list-errors {
  border-radius: 4px;
  margin-bottom: 20px;
  flex-wrap: wrap;
  gap: 10px;
  width: none !important;

  .el-tag {
    :hover {
      cursor: pointer;
    }
  }
}

.selector {
  display: none;
  position: fixed;
  border: 2px solid red;
  border-radius: 4px;
  z-index: 100;
}
</style>
